module.exports = __webpack_public_path__ + "shanz/static/media/profile.efe4e181.png";